var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser01Gray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 10.5C10 9.80222 10 9.45333 9.91388 9.16943C9.71998 8.53023 9.21977 8.03002 8.58057 7.83612C8.29667 7.75 7.94778 7.75 7.25 7.75H4.75C4.05222 7.75 3.70333 7.75 3.41943 7.83612C2.78023 8.03002 2.28002 8.53023 2.08612 9.16943C2 9.45333 2 9.80222 2 10.5M8.25 3.75C8.25 4.99264 7.24264 6 6 6C4.75736 6 3.75 4.99264 3.75 3.75C3.75 2.50736 4.75736 1.5 6 1.5C7.24264 1.5 8.25 2.50736 8.25 3.75Z",
    stroke: "#667085",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser01Gray);
export default __webpack_public_path__ + "static/media/user-01-gray.4c0cc2ec765b1c86222702b34b7bec37.svg";
export { ForwardRef as ReactComponent };